module.exports = __webpack_public_path__ + "img/1_novice_closer.341b48fb.png";